export default __webpack_public_path__ + "static/media/330_business03-jp-mobile.98068995.png";